$('#application-form__file').change(function () {
    let $filePath = $(this).val();
    let $fileName = $filePath.slice(12);
    if ($filePath.length != 0) {
        $('label.application-form__file').html($fileName + '<div class="remove_file">x</div>');
    }
});

$('body').on('click', '.remove_file', function(e){
  e.preventDefault();
  $('#application-form__file').val(null);
  $('label.application-form__file').html('Select files to upload');
});

$('.application-form .wpcf7').on('wpcf7mailsent', function () {
    $('label.application-form__file').text(translations.uploadFile);
});



// WEBPACK FOOTER //
// ./scripts/modules/application-form.js